import { Injectable } from "@angular/core"

@Injectable({
  providedIn: "root",
})
export class ColorPaletteService {
  // Neutral
  neutral0 = "#fafaf9"
  neutral50 = "#FAFAF9"
  neutral100 = "#f5f5f4"
  neutral200 = "#e7e5e4"
  neutral300 = "#d6d3d1"
  neutral400 = "#a8a29e"
  neutral500 = "#78716c"
  neutral600 = "#57534e"
  neutral700 = "#44403c"
  neutral800 = "#222222"
  neutral900 = "#1c1917"

  // Red
  red0 = "#fef2f2"
  red100 = "#fee2e2"
  red200 = "#fecaca"
  red300 = "#fca5a5"
  red400 = "#f87171"
  red500 = "#ef4444"
  red600 = "#dc2626"
  red700 = "#b91c1c"
  red800 = "#991b1b"
  red900 = "#7f1d1d"

  // Orange
  orange0 = "#fff7ed"
  orange100 = "#ffedd5"
  orange200 = "#fed7aa"
  orange300 = "#fdba74"
  orange400 = "#fb923c"
  orange500 = "#f97316"
  orange600 = "#ea580c"
  orange700 = "#c2410c"
  orange800 = "#9a3412"
  orange900 = "#7c2d12"

  // Yellow
  yellow0 = "#fefce8"
  yellow100 = "#fef9c3"
  yellow200 = "#fef08a"
  yellow300 = "#fde047"
  yellow400 = "#facc15"
  yellow500 = "#eab308"
  yellow600 = "#ca8a04"
  yellow700 = "#a16207"
  yellow800 = "#854d0e"
  yellow900 = "#713f12"

  // Green
  green0 = "#f0fdf4"
  green100 = "#dcfce7"
  green200 = "#bbf7d0"
  green300 = "#86efac"
  green400 = "#4ade80"
  green500 = "#22c55e"
  green600 = "#16a34a"
  green700 = "#15803d"
  green800 = "#166534"
  green900 = "#14532d"

  // Teal
  teal0 = "#f0fdfa"
  teal100 = "#ccfbf1"
  teal200 = "#99f6e4"
  teal300 = "#5eead4"
  teal400 = "#2dd4bf"
  teal500 = "#14b8a6"
  teal600 = "#0d9488"
  teal700 = "#0f766e"
  teal800 = "#115e59"
  teal900 = "#134e4a"

  // Blue
  blue0 = "#eff6ff"
  blue100 = "#dbeafe"
  blue200 = "#bfdbfe"
  blue300 = "#93c5fd"
  blue400 = "#60a5fa"
  blue500 = "#3b82f6"
  blue600 = "#2563eb"
  blue700 = "#1d4ed8"
  blue800 = "#1e40af"
  blue900 = "#1e3a8a"

  // Brand
  brand0 = "#F1F5FD"
  brand100 = "#E0E9F9"
  brand200 = "#C8D9F5"
  brand300 = "#A2C1EE"
  brand400 = "#76A0E4"
  brand500 = "#5580DC"
  brand600 = "#4568D0"
  brand700 = "#3753BE"
  brand800 = "#33459A"
  brand900 = "#2D3C7B"

  // Purple
  purple0 = "#faf5ff"
  purple100 = "#f3e8ff"
  purple200 = "#e9d5ff"
  purple300 = "#d8b4fe"
  purple400 = "#c084fc"
  purple500 = "#a855f7"
  purple600 = "#9333ea"
  purple700 = "#7e22ce"
  purple800 = "#6b21a8"
  purple900 = "#581c87"

  // Pink
  pink0 = "#fdf2f8"
  pink100 = "#fce7f3"
  pink200 = "#fbcfe8"
  pink300 = "#f9a8d4"
  pink400 = "#f472b6"
  pink500 = "#ec4899"
  pink600 = "#db2777"
  pink700 = "#be185d"
  pink800 = "#9d174d"
  pink900 = "#831843"
}
